import { Outlet } from '@remix-run/react';

import { DynamicHeader } from '~/components/DynamicHeader';
import useRegion from '~/hooks/useRegion';
import Footer from '~/legacy/components/footer';

export default function MainMenuTemplate() {
  const region = useRegion();

  return (
    <>
      <DynamicHeader region={region} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
